module.exports = __webpack_public_path__ + "static/media/scroll-down-communihelp.b262096d.svg";